export const APPOINTMENT_TABLE_HEADERS = [
  { key: "patient", label: "Patient Name", align: "left" as const },
  { key: "doctor", label: "Doctor", align: "left" as const },
  { key: "datetime", label: "Date & Time", align: "left" as const },
  { key: "location", label: "Session / Room / Token", align: "left" as const },
  { key: "status", label: "Status", align: "left" as const },
  { key: "purpose", label: "Purpose", align: "left" as const },
  { key: "action", label: "Action", align: "center" as const },
];

export const statusStyles: Record<string, string> = {
  ongoing:
    "bg-lime-100 dark:bg-lime-900/40 text-lime-700 dark:text-lime-300 border-lime-300 dark:border-lime-600",
  waiting:
    "bg-violet-100 dark:bg-violet-900/40 text-violet-700 dark:text-violet-300 border-violet-300 dark:border-violet-600",
  inqueue:
    "bg-sky-100 dark:bg-sky-900/40 text-sky-700 dark:text-sky-300 border-sky-300 dark:border-sky-600",
  canceled:
    "bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300 border-red-300 dark:border-red-600",
  completed:
    "bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300 border-emerald-300 dark:border-emerald-600",
  appointment:
    "bg-orange-100 dark:bg-orange-900/40 text-orange-700 dark:text-orange-300 border-orange-300 dark:border-orange-600",
  reschudle:
    "bg-cyan-100 dark:bg-cyan-900/40 text-cyan-700 dark:text-cyan-300 border-cyan-300 dark:border-cyan-600",
  noshow:
    "bg-slate-100 dark:bg-slate-600 text-slate-700 dark:text-slate-200 border-slate-300 dark:border-slate-500",
  default:
    "bg-white dark:bg-slate-700 text-slate-600 dark:text-slate-300 border-slate-200 dark:border-slate-600",
};

export const FIELD_LABELS = {
  dateTime: "Date & Time",
  location: "Session / Room / Token",
  doctor: "Doctor",
  status: "Status",
  purpose: "Purpose",
  type: "Type",
  queue: "Token number",
} as const;

/** Parse queue input; empty string → 0. Returns null if invalid. */
export function parseQueueInput(raw: string): number | null {
  const trimmed = String(raw ?? "").trim();
  if (trimmed === "") return 0;
  if (!/^\d+$/.test(trimmed)) return null;
  const n = parseInt(trimmed, 10);
  return Number.isFinite(n) && n >= 0 ? n : null;
}

export function formatQueueFromItem(item: { queue?: unknown }): string {
  if (item?.queue != null && item?.queue !== "") {
    return String(Number(item.queue));
  }
  return "";
}
